<template>
  <div class="popup_title">
    <slot></slot>
    <div
      class="popup_title-hint"
      v-html="titleText"
    ></div>
  </div>
</template>
<script>
export default {
  name: "PopupTitle",
  props: {
    titleText: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.popup_title {
  position: relative;
  /* z-index: 0; */
}
.popup_title-hint {
  top: calc(100% + 6px);
  position: absolute;
  background-color: #172935;
  color: #fff;
  font-size: 12px;
  padding: 5px 7px;
  left: 50%;
  transform: translateX(-50%);
  display: none;
  opacity: 0;
  transition: all 0.2s;
  white-space: nowrap;
  text-align: center;
  /* z-index: 1; */
}
.popup_title-hint::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 6px 6px 6px;
  border-color: transparent transparent #172935 transparent;
  /* z-index: 1; */
}
.popup_title:hover .popup_title-hint {
  display: block;
  opacity: 1;
}
</style>
